export const getSujetDimensionsByCoordinates = (coordinates = []) => {
  if (!coordinates.length) {
    return false
  }

  const topLeft = coordinates[0]
  const bottomRight = coordinates[2]

  const width = bottomRight[0] - topLeft[0]
  const height = bottomRight[1] - topLeft[1]
  // const gcdValue = getGreatestCommonDivisor(width, height)

  return {
    width,
    height,
    // aspectRatio: `${width / gcdValue}:${height / gcdValue}`,
    aspectRatio: `${width}x${height}`,
  }
}

// const getGreatestCommonDivisor = (x, y) => {
//   if (typeof x !== 'number' || typeof y !== 'number') {
//     return false
//   }

//   x = Math.abs(x)
//   y = Math.abs(y)

//   while (y) {
//     const t = y
//     y = x % y
//     x = t
//   }
//   return x
// }
